import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import axios from 'axios';
import { tripDutyTypeEnum } from "utils/enumObj";

let env = process.env.REACT_APP_B2B_API_BASE_URL;

const requestInstance = axios.create({
  baseURL: env,
});

export const autocompleteApi = async (data) => {
  let url
  //if(data?.dutyType === tripDutyTypeEnum.roundTrip  && data?.locationType === 'drop'){
    url = `${env}${API_ENDPOINT.GoogleMap.autocompleteApi}?name=${data?.name}&location=${data?.location}`;
  // }else{
  //   url = `${env}${API_ENDPOINT.GoogleMap.nearbysearch}?name=${data?.name}&location=${data?.location}`;
  // }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const placeApi = async (data) => {
  let url = `${env}${API_ENDPOINT.GoogleMap.placeApi}?placeId=${data?.placeId}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};


export const directionApi = async (data) => {
  let url = `${env}${API_ENDPOINT.GoogleMap.directionApi}?destLat=${data?.destination?.lat}&destLng=${data?.destination?.lng}&orgLat=${data?.origin?.lat}&orgLng=${data?.origin?.lng}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};


export const geocodeApi = async (data) => {
  let url = `${env}${API_ENDPOINT.GoogleMap.geocodeApi}?latlng=${data?.latlng}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const rideDetailsPolyLines = async (data) => {
  let url = `${env}${API_ENDPOINT.liveTrips.api}/${data}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
